// extracted by mini-css-extract-plugin
export default {"brandguideOptions":"SNYbKAGHZqiTlrI3+x6DNoMFQgCcM9d-BV7nChNx8GI="};